import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import accountBg from 'assets/images/bg/bgHome.jpg';
import bgGuide from 'assets/images/icons/bg-guide.png';

const lotteryPageStyles = {
    wrapPage: css`
        background: url(${accountBg}) no-repeat;
        background-size: cover;
        height: 100%;
        /* padding: 24px 0; */
    `,
    wrapInner: css`
        display: flex;
        overflow: hidden;
        height: 100%;
    `,
    sidebar: css`
        flex: 0 0 240px;
        max-width: 240px;
        border-right: 1px solid #dfeeff;
        padding: 24px 20px;
    `,
    betContainer: css`
        /* padding: 16px; */
        flex: 1;
    `,
    resultSection: css`
        display: flex;
        gap: 20px;
        /* margin-bottom: 24px; */
        color: ${colors.white};
        padding: 8px;
        background: ${colors.primary};
    `,

    issueWrap: css`
        /* flex: 1; */
        width: 300px;
        margin-left: auto;
        /* background: linear-gradient(65deg, rgba(9, 111, 112, 0.5) 15%, rgba(13, 49, 76, 1) 100%); */
        /* border-radius: 6px; */
        padding: 10px 8px;
        /* border: 1px solid ${colors.darkPrimary}; */
        display: flex;
        flex-direction: column;
        align-items: center;
        /* justify-content: center; */
    `,
    topCount: css`
        background-color: #000;
        padding: 9px 10px 8px;
        color: #fff;
        font-size: 17px;
        text-align: center;
        width: 100%;
    `,
    containerTopCount: css`
        width: 100%;
        padding: 10px 10px 4px;
        background-image: linear-gradient(to bottom, #e4bc62, #dec887);
    `,
    resultSpecial: css`
        text-align: center;
        border-bottom: 1px solid #7793a3;
        padding-top: 16px;
        p {
            font-size: 18px;
            &:first-child {
                span {
                    color: ${colors.yellow};
                    font-weight: 500;
                }
            }
        }
    `,
    specialLotteryHistory: css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 18px 0;

        span {
            width: 36px;
            height: 36px;
            line-height: 34px;
            text-align: center;
            border-radius: 36px;
            background: ${colors.white};
            border: 1px solid ${colors.borderPrimary};
            color: ${colors.blackText};
            font-size: 20px;
            font-weight: 600;
        }
    `,
    nextIssue: css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1;
    `,
    chanelLottery: css`
        font-size: 24px;
        color: ${colors.yellow};
        font-weight: 600;
        padding: 8px 0;
    `,
    timerCountLeft: css`
        margin-bottom: 8px;
        color: black;
        text-align: center;
    `,
    timerCountDown: css`
        display: flex;
        justify-content: center;
    `,
    betSection: css`
        background-color: #f4f4f4;
    `,
    currentIssue: css`
        margin-top: 16px;
        color: black;
        text-align: center;
        span {
            /* color: ${colors.yellow}; */
            font-weight: 300;
        }
    `,
    viewButton: css`
        display: flex;
        gap: 20px;
        padding-left: 5px;
        padding-right: 5px;
        gap: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        .button {
            background-image: linear-gradient(30deg, #023639, #056369, #023639);
            width: 100%;
            height: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            box-shadow: 0 8px 6px -6px #000000cf;
            display: flex;
            cursor: pointer;
        }

        .buttonBottom {
            background-image: linear-gradient(30deg, #ffffff, #d5d6d6, #d5d6d6);
            width: 100%;
            height: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            box-shadow: 0 8px 6px -6px #000000cf;
            display: flex;
            color: black;
            cursor: pointer;
        }
    `,

    tabTypeBetList: css`
        display: flex;
        background: linear-gradient(to bottom, #056369 0%, #023639 50%);
        width: 100%;
        height: 47px;
    `,
    tabTypeItem: css`
        padding-top: 12px;
        padding-bottom: 12px;
        padding-left: 28px;
        padding-right: 28px;
        text-align: center;
        color: ${colors.white};
        cursor: pointer;
        position: relative;
        overflow: hidden;
        float: left;
        margin-left: -1px;
        border-bottom: none;
        border-width: 1px;
        border-style: solid;
        border-image: linear-gradient(to top, #14805e, rgba(0, 0, 0, 0)) 1 100%;

        &.active {
            background-color: #f4f4f4;
            span {
                color: ${colors.black};
            }
            &::before {
                opacity: 1;
            }
        }
        span {
            position: relative;
            z-index: 1;
            font-weight: 500;
        }
    `,
    subTabTypeBetList: css`
        display: flex;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        justify-content: space-between;
        background-color: #f4f4f4;
        padding-bottom: 10px;
        align-items: flex-start;
        p {
            margin-left: auto;
            font-size: 14px;
        }
        .containerLo {
            display: flex;
            align-items: center;
            gap: 20px;
        }
        .containerType {
            display: flex;
            align-items: center;
            border: 1px solid #979797;
        }
    `,
    subTabTypeBetItem: css`
        border-radius: 4px;
        font-weight: 300;
        color: black;
        box-shadow: 0 8px 6px -6px #000000cf;
        cursor: pointer;
        background: white;
        font-size: 15px;
        padding: 8px 18px;

        &.active {
            color: ${colors.white};
            background-color: ${colors.primary};
        }
    `,
    viewHealp: css`
        display: flex;
        border-radius: 3px;
        align-items: center;
        padding-right: 20px;
        .star {
            position: relative;
            left: 25px;
        }

        .helpView {
            background-image: url(${bgGuide});
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            height: 40px;
            width: 100%;
            align-items: center;
            justify-content: center;
            p {
                line-height: 40px;
                padding-left: 35px;
                color: #282c35 !important;
            }
        }
    `,
    infoBet: css`
        padding-left: 20px;
        padding-top: 5px;
        span {
            color: #d90500;
            font-weight: 500;
        }
    `,
    inputBetWrap: css`
        padding: 20px 20px;
        margin-top: 10px;
        background: #e5e5e5;
    `,
    tabInputBetList: css`
        display: flex;
        gap: 30px;
        border-bottom: 1px solid #bce1e1;
    `,
    tabInputBetItem: css`
        /* padding: 8px 4px; */
        /* border-bottom: 4px solid transparent; */
        cursor: pointer;
        background: linear-gradient(to bottom, #fefefe 0%, #d5d5d5 100%);
        color: ${colors.primary};
        font-size: 13px;
        padding: 3px 30px 5px;
        border-right: 1px solid #979797;
        align-self: baseline;
        box-sizing: border-box;
        &.active,
        :hover {
            border-color: ${colors.darkPrimary};
            box-shadow: inset 0px 0px 4px rgba(51, 51, 51, 0.53);
        }
        &:last-child {
            border-right: none;
        }
    `,

    betTimesInput: css`
        display: flex;
        align-items: center;
        padding: 4px 4px;
        border-radius: 6px;
        border: 1px solid ${colors.darkPrimary};
        background-color: ${colors.primary};
        input {
            border: none;
            outline: none;
            width: 50px;
            text-align: center;
            color: white;
            background-color: transparent;
        }
        button {
            border: 1px solid ${colors.lightBlue};
            background: white;
            border-radius: 4px;
            width: 22px;
            height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: black;
            font-size: 14px;
            &:active {
                background: ${colors.darkPrimary};
                svg {
                    color: ${colors.white};
                }
            }
            svg {
                color: ${colors.darkPrimary};
            }
        }
    `,
    betAction: css`
        padding-top: 10px;
        padding-bottom: 10px;
    `,
    betMulti: css`
        display: flex;
        align-items: center;
        gap: 8px;
        .backgroundWhite {
            background-color: transparent;
            padding-right: 0px;
            padding-top: 10px;
            padding-bottom: 10px;
        }
    `,
    betActionGroup: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 40px;
        background-color: white;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
    `,

    betNotice: css`
        font-size: 12px;
        span {
            color: ${colors.red};
        }
    `,
    betActionBtn: css`
        display: flex;
        gap: 8px;
        /* flex: 0 0 40%; */
        button {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 4px;
            text-align: center;
        }
    `,
    btnOrder: css`
        height: 40px;
        width: 180px;
        color: ${colors.blackText};
        font-size: 20px;
        background: ${colors.orange};
        background-image: linear-gradient(to bottom, #ffc857, #ffad33);
        display: inline-block;
        vertical-align: middle;
        border-radius: 3px;
        padding: 0 15px;
        margin-right: 5px;
        border: 2px solid #c9820a;
        span {
            color: ${colors.blackText} !important;
            width: 100%;
            font-weight: 300 !important;
        }
    `,
    btnAddOrder: css`
        width: 200px;
        border: none;
        background-color: ${colors.primary};
        font-size: 20px;
        padding: 0 15px;
        color: #fff;
        border-radius: 5px;
        span {
            color: #fff !important;
            width: 100%;
            font-weight: 300 !important;
        }
    `,
    betInfo: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 20px;
        span {
            color: ${'#c74726'};
            font-weight: 500;
        }
    `,
    betInfoLeft: css`
        border: 1px dashed #c74726;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 5px;
    `,
    betInfoRight: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        label {
            font-size: 16px;
            display: inline-block;
            margin-right: 8px;
        }
        select {
            padding: 4px 8px;
            border-radius: 8px;
            background: ${colors.white};
            color: ${colors.black};
            border: 1px solid ${colors.lightBlue};
        }
    `,
    selectRateBet: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        /* margin-bottom: 8px; */
    `,

    wrapBet1kAction: css`
        display: flex;
        align-items: center;
        p {
            margin-left: 8px;
        }
    `,
    btnBetAll: css`
        /* display: flex;
        align-items: center;
        gap: 4px;
        padding: 10px 0;
        width: 70%;
        margin-left: auto; */
        background-image: linear-gradient(to bottom, #ffc857, #ffad33);
        padding: 5px 15px 4px;
        color: ${colors.blackText};
        border-radius: 3px;
        cursor: pointer;
        font-size: 22px;
        font-weight: 700;
    `,
    countdownBtn: css`
        color: ${colors.blackText};
        font-size: 12px;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-left: 1px solid rgba(26, 32, 44, 0.35);
        margin-left: 7px;
        padding-left: 10px;
        p {
            /* vertical-align: middle; */
            text-align: center;
            line-height: 19px;
        }
    `,
    totalMoneyBet: css`
        display: flex;
        align-items: center;
        span {
            font-size: 20px;
            font-weight: 500;
            margin-left: 4px;
            color: red;
            padding-right: 5px;
        }
    `,
    noResult: css`
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    `,
};
export default lotteryPageStyles;
